/**
 * Created by  on 01.04.16.
 */
(function($){
  /**
   * State
   * @type {null|object}
   */
  let state = null;

  /**
   * current page
   * @type {number}
   */
  let currentPage = 0;

  /**
   * Item per site
   * @type {number}
   */
  let itemPerSite = 10;

  /**
   * Portfolio Container
   * @type {jQuery}
   */
  let portfolio = null;

  /**
   * requestRunning indicates if a xhr request is running
   * @type {boolean}
   */
  let requestRunning = false;

  /**
   * All items are loaded and no more items are available
   * @type {boolean}
   */
  let allItemLoaded = false;

  /**
   * Scroll threshold
   * @type {number}
   */
  const threshold = 200;


  /**
   * load items over Ajax and execute callback
   * @param {string} category
   * @param {function} callback
   * @return {Promise}
   */
  function getItems( category, callback) {
    return $.ajax({
      url: '/wp/wp-admin/admin-ajax.php',
      type: 'post',
      data: {
        action: 'portfolio_plugin_get_items',
        category: category,
        item_per_site: itemPerSite,
        site: currentPage * itemPerSite
      },
      dataType: 'json',
      success: function (response) {
        // callback
        state = category;
        callback(response);
        portfolio.trigger('loaded', response.cat)
        return response;
      },
      error: function () {
        console.log("Error: Could not load entity");
      }
    });
  }

  /**
   * Create a portfolio item
   * @param {object} data
   * @returns {jQuery|void}
   */
  function createElem (data) {
    // make category description
    const description = $("<div/>", {"class": "description"}).text(data.excerpt)
    const $cats = $("<ul/>", {"class": "portfolio-categories"});
    data.categories.forEach((d) => {
      $cats.append($("<li/>").append($('<a/>', {"href": d.url, "class": "portfolio-cat nav-element"}).text(d.name)));
    });

    return  $('<div/>', {'class' : 'portfolio_item'}).append(
      $("<a/>",{'href': data.permalink}).append(
        $("<div/>", {"class": "image-container"}).append($(data.image))
      ).append(
        $("<h2/>", {"class": "entry-title portfolio"}).text(data.title)
      )
    ).append(
      description.append($cats)
    );
  }

  /**
   * Create category item
   * @param data
   * @return {*|jQuery|HTMLElement}
   */
  function createCat(data) {
    const $cat = $("<div/>", {"class": "cat"});
    $cat.append($("<p/>").html(data.description))
    return $cat;
  }

  /**
   * Create page header
   * @param data
   * @return {jQuery.fn.init|jQuery|HTMLElement}
   */
  function createTitle(data) {
    const $header = $("<div/>", {"class": "page-header"});
    $header.append($("<h1/>").html("#" + data.name));
    return $header;
  }

  /**
   * Get the current category from location.href or state
   * @return {string}
   */
  function getCategorySlug() {
    // populate state from url
    const url = window.location.href;
    let category = "";
    let match;
    if((match = url.match(/portfolio\/category\/([-a-z0-9]+)\/?/)) != null){
      category = match[1];
    } else if(state !== null) {
      if(typeof state.category !== 'undefined')  {
        category = state.category;
      }
    }
    return category
  }
  /**
   * Default callback for click events
   * We use this to trigger a click on a cat button or n history popstate
   * @param content
   */
  function defaultCallback(content){
    // refill portfolio-container
    portfolio.isotope('remove', $('*'));
    $.each(content.data, function (index, data){
      const elem = createElem(data);
      portfolio.append( elem ).isotope('appended', elem);
    })
    portfolio.imagesLoaded().progress( function() {
      portfolio.isotope('layout');
      // reset state
      allItemLoaded=false;
      requestRunning = false;
    });

    // Update category information
    const $cat = $(".main > .cat")
    const $pageHeader = $(".main > .page-header")
    // create missing cat description container
    if($cat.length === 0) {
      $pageHeader.after($("<div/>", {"class": "cat"}));
    }
    $cat.replaceWith(createCat(content.cat));
    $pageHeader.replaceWith(createTitle(content.cat));
  }

  /**
   * Handle history api
   * @param event
   */
  function historyCallback(event) {
    const historyState = event.state;
    // we need to reset the counter
    currentPage = 0;
    let cat = '';
    if( historyState !== null) {
      cat = historyState.category;
    }
    getItems(cat, defaultCallback).then(() => {
      portfolio.trigger('loaded','');
    });
  }

  /**
   * Handle Scroll event and load more data from the same cat
   */
  function scroll(){
    // load items if document end is reached and some elements are left on the server
    if($(window).scrollTop() + $(window).height() > ($(document).height() - threshold) && !requestRunning && !allItemLoaded){
      requestRunning = true;
      // get next site
      currentPage = Math.max(0, currentPage) + 1;
      const category = getCategorySlug()

      // callback
      function callback (content){
        // no more items
        if(content.length === 0){
          allItemLoaded = true;
          return;
        }

        // add items to masonry
        $.each(content.data, function (index, data){
          const elem = createElem(data);
          portfolio.append( elem ).isotope('appended', elem);
        });
        // load images of the masonry
        portfolio.imagesLoaded().progress( function() {
          portfolio.isotope('layout');
          requestRunning = false;
        });
      }
      getItems(category, callback).then(() => {});
    }
  }

  /**
   * all methods of the plugin
   * @type {{init: (function(*=): *)}}
   */
  const methods = {
    init: function (options){
      return this.each(function() {
        const opts = $.extend({scroll: true}, options)
        portfolio = $(this);
        // init portfolio
        portfolio.isotope({
          // options
          masonry: {
            columnWidth: '.grid-sizer',
            gutter: '.grid-gutter'
          },
          itemSelector: '.portfolio_item',
          percentPosition: true
        });

        // load images and rerender layout
        portfolio.imagesLoaded().progress( function() {
          portfolio.isotope('layout');
        });

        /**
         * Listen to popState event (gets fired when clicking
         * forward or back button in browser)
         */
        window.onpopstate = historyCallback

        /**
         * Handle scroll event
         */
        if(opts.scroll) {
          $(window).on('scroll', scroll);
        }
        // open portfolio on click on portfolio_item
        portfolio.on('click', '.portfolio_item', function (e) {
          if($(e.target).is("a")) {
            return
          }
          window.location.href =  $(this).find("a").attr("href");
        })
      });
    },
    /**
     * Load data of the portfolio. If a category is provided load all category items, if not load all portfolio items
     * @param category
     */
    load: function(category) {
      if(category === null || typeof category === "undefined" ) {
        category = "";
      }
      // reset site counter
      currentPage = 0;
      // get items
      getItems(category, defaultCallback).then((content) => {
        // scroll to the top
        $(window).scrollTop(0);
        // change state
        history.pushState({
          'category': content.cat.slug
        }, content.cat.name, content.cat.permalink);

      });
    }
  };

  /**
   * declare plugin with methods
   * @param methodOrOptions
   * @returns {*}
   */
  $.fn.portfolio = function(methodOrOptions)
  {
    if (methods[methodOrOptions])
    {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions)
    {
      // Default to "init"
      return methods.init.apply(this, arguments);
    } else
    {
      $.error('Method ' + methodOrOptions + ' does not exist on jQuery.tooltip');
    }
  };

})(jQuery);

/**
 * Init plugin for portfolio-cat links
 */
(function ($) {
  $(document).ready(function () {
    const $body = $("body");
    const $portfolioContainer = $(".portfolio-container")

    if($body.hasClass("home")) {
      $portfolioContainer.portfolio({scroll: false});
    } else {
      $portfolioContainer.portfolio();
    }

    /**
     * Click on a portfolio-cat link on the site
     */
    $body.on("click", "a.portfolio-cat", function(e) {
      const url = $(e.currentTarget).attr('href');
      let match;
      if((match = url.match(/portfolio\/category\/([-a-z0-9]+)\/?/)) != null && $portfolioContainer.length > 0) {
        e.preventDefault();
        let category = match[1];
        $portfolioContainer.portfolio("load", category);
      }
    });

    // Change menu and select current item
    $portfolioContainer.on("loaded", function(event, category) {
        $('a.portfolio-cat[aria-current="page"]').removeAttr('aria-current');
        const link = $('a[href$="' + category.slug + '/"]');
        link.parents('li').siblings().find('a[aria-current="page"]').removeAttr('aria-current')
        link.attr('aria-current',"page");
      });

    // trigger portfolio mouseover effects
    // todo: css only
    $portfolioContainer
      .on('mouseover', '.portfolio_item', (e) => {
        $(e.currentTarget).addClass('hover');
      }).on('mouseout', '.portfolio_item', (e) => {
      $(e.currentTarget).removeClass('hover');
    });
  });
})(jQuery);
